import { call, put, takeEvery } from 'redux-saga/effects';
import {
  fetchCloudServicesRequest,
  fetchCloudServicesSuccess,
  fetchCloudServicesFailure,
} from './slice';
import {
  CatalogItem 
} from "utility/constants";
import {fetchCloudProvisioningServices} from "services/cloudProvisioningService";
import { reactToastify, ToastType } from "utility/reactToastify";

function* callToFetchCloudServices() {
  try {
    const response: CatalogItem[]  = yield call(fetchCloudProvisioningServices);   
    if (Array.isArray(response)) {
      yield put(fetchCloudServicesSuccess(response));
    } else {
      yield put(fetchCloudServicesFailure('Invalid data format received'));
      reactToastify({ type: ToastType.error, message: "Failed to load cloud services", description: "Unable to fetch cloud provisioning services." });
    }
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || 
                        error?.message || 
                        'Failed to fetch cloud services';
    yield put(fetchCloudServicesFailure(errorMessage));
    reactToastify({ type: ToastType.error, message: "Failed to load cloud services", description: "Unable to fetch cloud provisioning services." });
  }
}

export function* callToFetchCloudServicesWatcher() {
  yield takeEvery(fetchCloudServicesRequest.type, callToFetchCloudServices);
}